import { Injectable } from '@angular/core';
import { IQueueEntry, TrackJsErrorLogService } from '@legalzoom/business-formation-sdk';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { ProductName } from '../constants/product-domain';
import { IDeleteQuestionnaireAnswerResponse, QuestionnaireAnswerService as SdkQuestionnaireAnswerService, } from '@legalzoom/questionnaire-answer-sdk';
@Injectable({
  providedIn: 'root'
})
export class QuestionnaireAnswerService {

  constructor(private sdkQuestionnaireAnswerService: SdkQuestionnaireAnswerService, private trackJsErrorLogService: TrackJsErrorLogService) { }
  prepareGetUserAnswers(context: any, customerId: number, processingOrderId: number, productName: ProductName): IQueueEntry {
    const that = this;
    return {
      name: 'prepareGetUserAnswers questionnaire-answer.service ' + context.constructor.name,
      pre: () => {
        return that.sdkQuestionnaireAnswerService.getUserAnswers(customerId, processingOrderId);
      },
      post: (response) => {
        if (!!response) {
          context.userAnswers = response;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        this.trackJsErrorLogService.track(productName, 'questionnaire-answer.service' + context.constructor.name, error);
        return of(null);
      }
    };
  }
  prepareDeleteQuestionnaireAnswers(context: any, customerId: number, productName: ProductName,
                                    successDeleteQuestionnaireAnswers: (response: IDeleteQuestionnaireAnswerResponse) => void): IQueueEntry {
    const that = this;
    return {
      name: 'deleteQuestionnaireAnswers questionnaire-answer.service ' + context.constructor.name,
      pre: () => {
        if (!context.questionnaireStorage && !!context.userAnswers) {
          console.log(context.userAnswers);
          return that.sdkQuestionnaireAnswerService.deleteQuestionnaireAnswers(customerId, context.userAnswers);
        }
        return of(false);
      },
      post: (response) => {
        console.log('prepareDelete return');
        successDeleteQuestionnaireAnswers(response);
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        this.trackJsErrorLogService.track(productName, 'questionnaire-answer.service' + context.constructor.name, error);
        return of(null);
      }
    };
  }
}
